import React from "react";

const ProjectBar = (props) => {
  return (
    <div className="projectBar">
      <div className="projectBarText">
        <h2>{props.projectName}</h2>
        <p>{props.projectDescription}</p>
        <a href={props.projectLink} target="_blank" rel="noopener noreferrer" className="Link">
          Link
        </a>
      </div>
    </div>
  );
};

export default ProjectBar;
